/**
 * Auth-Welle Phase 2 (19.09.2026) — kein Zwangs-Login mehr.
 *
 * Ronni: die Seite soll auch ohne Anmeldung erreichbar sein. Diese Datei
 * leitet deshalb NICHT mehr auf /login um, wenn keine Session da ist.
 *
 * WICHTIG, was das NICHT bedeutet: Die Datenbank bleibt über RLS
 * geschützt (`v5_*`-Tabellen verlangen die Rolle `authenticated`, siehe
 * CLAUDE.md „Migrationen"). Ein Besucher ohne Session sieht also die
 * Oberfläche, aber keine echten Watchlist-/Positions-/Trade-Plan-Daten —
 * die Abfragen laufen leer. Wer wirklich handeln will, meldet sich über
 * /login weiterhin an. Das war ausdrücklich die Abwägung: Zugang ohne
 * Hürde, aber kein öffentliches Lesen/Schreiben echter Daten (siehe die
 * RLS-Reparaturen vom 10.08. und 19.08.2026 — genau das sollten sie
 * verhindern).
 */

import type { ReactNode } from 'react';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  return <>{children}</>;
}
